import React, { FC, useCallback } from 'react';
import styles from '../index.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-light-svg-icons';
import { confirm } from 'src/common';
import modalStyles from 'src/common/Modal/index.module.scss';
import { useTranslation } from 'react-i18next';
import { Keyword } from '@tendium/prom-types';
import { useApiTenders } from 'src/models/procurements/Tenders/hooks';

interface IProps {
  keyword: Keyword;
}

export const DeleteButtonQuickFilter: FC<IProps> = props => {
  const { keyword } = props;
  const { t } = useTranslation();
  const [{ vars: searchArgs }, updateSearchArgs] = useApiTenders();

  const removeKeyword = useCallback((): void => {
    const newKeywordsState: Keyword[] = searchArgs?.keywordArgs?.filter(k => k.value !== keyword.value) || [];
    updateSearchArgs({ keywordArgs: newKeywordsState });
  }, [keyword, searchArgs?.keywordArgs, updateSearchArgs]);

  const onDelete = useCallback(() => {
    confirm.confirm({
      title: t('Tenders.removeKeyword'),
      okText: t('Common.delete'),
      content: t('Tenders.removeKeywordDescription'),
      cancelText: t('Common.cancel'),
      className: modalStyles.confirmModal,
      centered: true,
      onOk() {
        removeKeyword();
      }
    });
  }, [removeKeyword, t]);

  return (
    <button className={styles.deleteButton} onClick={onDelete}>
      <FontAwesomeIcon icon={faTimes} />
    </button>
  );
};

export default DeleteButtonQuickFilter;
